module.exports = __webpack_public_path__ + "assets/hoppa2.jpg?79a184e5128a9cf4f308254f9e7050c5";